import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const GeolocationIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 22.5 22.5"
    >
      <defs>
        <clipPath>
          <rect width="22.5" height="22.5" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath)">
        <path
          d="M3.238,11.25a8.011,8.011,0,1,1,8.012,8.012A8.012,8.012,0,0,1,3.238,11.25Z"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          cx="2.741"
          cy="2.741"
          r="2.741"
          transform="translate(8.509 8.509)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="2.304"
          transform="translate(0.75 11.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="2.296"
          transform="translate(19.454 11.25)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y1="2.417"
          transform="translate(11.25 0.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y1="2.488"
          transform="translate(11.25 19.262)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
